{
  "nl": {
    "admin": {
      "features": {
        "title": "Feature Flags",
        "description": "Feature Flags voor jouw account activeren of deactiveren. Wijzigingen worden bij de volgende paginaweergave van kracht.",
        "search": "Features zoeken...",
        "noResults": "Geen features gevonden.",
        "activatedForYou": "Al voor jou geactiveerd",
        "globallyActive": "Voor iedereen geactiveerd",
        "tabsLabel": "Feature-Flag-gebieden",
        "tabs": {
          "mine": "Mijn Features",
          "management": "Feature-Flag-beheer",
          "permanent": "Permanente Flags"
        }
      },
      "featureFlags": {
        "description": "Feature Flags voor alle gebruikers – niet alleen voor jouw eigen account (anders dan in het tabblad 'Mijn Features').",
        "permanentDescription": "Permanente infrastructuur-Flags (bijv. OAuth-loginproviders) voor alle gebruikers – zonder opruimworkflow of activeringsdatum.",
        "search": "Flags doorzoeken...",
        "noResults": "Geen Feature Flags gevonden.",
        "activatedAt": "Geactiveerd op {date}",
        "reviewWarning": {
          "title": "Deze Feature Flags moeten worden gecontroleerd en eventueel worden verwijderd:",
          "staleActivation": "meer dan een week geleden geactiveerd"
        },
        "state": {
          "on": "Geactiveerd",
          "conditional": "Gedeeltelijk geactiveerd",
          "off": "Gedeactiveerd"
        },
        "gatesSummary": {
          "actors": "{count} gebruiker | {count} gebruikers",
          "groups": "{count} groep | {count} groepen",
          "percentageOfActors": "{value} % van de gebruikers",
          "percentageOfTime": "{value} % van de tijd"
        },
        "detail": {
          "title": "Flag beheren: {name}",
          "booleanSection": "Volledig geactiveerd",
          "booleanHint": "Schakelt de Flag voor alle gebruikers in of uit.",
          "enabledLabel": "Voor iedereen geactiveerd",
          "actorsSection": "Individuele gebruikers",
          "actorsHint": "Gebruikers zoeken en vrijschakelen.",
          "actorsSearchLabel": "Gebruiker zoeken",
          "actorsSearchPlaceholder": "Naam of e-mail invoeren...",
          "actorUnresolved": "Onbekende gebruiker",
          "removeActor": "Verwijderen",
          "groupsSection": "Groepen",
          "percentageOfActorsSection": "Percentage gebruikers",
          "percentageOfTimeSection": "Percentage tijd",
          "percentageSave": "Opslaan",
          "clearGates": "Alle vrijschakelingen resetten",
          "clearGatesConfirm": "Alle vrijschakelingen (gebruikers, groepen, percentages) voor '{name}' echt resetten? Dit kan niet ongedaan worden gemaakt.",
          "clearGatesConfirmButton": "Resetten",
          "clearGatesCancel": "Annuleren",
          "activationSection": "Activeringsgeschiedenis",
          "activatedBy": "Geactiveerd door {name} op {date}",
          "neverActivated": "Nooit volledig geactiveerd.",
          "close": "Sluiten"
        },
        "toast": {
          "updated": "Feature Flag bijgewerkt.",
          "error": "Actie mislukt. Probeer het opnieuw."
        }
      }
    }
  }
}
